import React, { FunctionComponent } from 'react';
import { Icon } from '@blueprintjs/core';
import i18n from 'i18n';
import './additional-target-info-status.scss';

type AdditionalTargetInfoStatusProps = {
  isValid?: boolean
  disabled?: boolean
}

const AdditionalTargetInfoStatus: FunctionComponent<AdditionalTargetInfoStatusProps> = ({
  isValid,
  disabled,
}: AdditionalTargetInfoStatusProps) => {
  let text = i18n.t('warrant.target.form.reviewAdditionalTarget');
  let className = 'required-info';

  if (isValid) {
    text = i18n.t('warrant.target.form.additionalTargetOk');
    className = 'fulfilled-info';
  }

  if (disabled) {
    className += ' disabled-info';
  }

  return (
    <div title={text} className={`additional-target-info-status ${className}`}>
      {text}
      <Icon className="required-icon" icon="error" intent="danger" iconSize={15} />
      <Icon className="fulfilled-icon" icon="tick" intent="success" iconSize={15} />
    </div>
  );
};

export default AdditionalTargetInfoStatus;
